import { Model } from "@rematch/core";
import {
  GetDepositPaymentInfoFuncParams,
  GetDepositPaymentInfoResponse
} from "shared/functions/getDepositPaymentInfo";
import { IApplication } from "shared/model/IApplication";
import { IAchTransactionInfo } from "shared/model/ITransaction";

import {
  IRefreshablePropSubState,
  IRemoteActionSubState
} from "../../model/SharedTypes";
import { StateModules } from "../types";
import { IState } from "./..";
import { fetchPaymentInfo, postMemberPayment } from "./PaymentEffects";
import { OpaqueData } from "shared/functions/membersApi/types/IUserAccountFuncResponse";

export interface IPaymentModel extends Model {
  name: StateModules;
  state: IPaymentState;
  reducers: IPaymentReducers;
  effects: IPaymentEffects;
}

export type IPaymentState = {
  memberPayment: IRemoteActionSubState<void>;
  monthlyFee: IRefreshablePropSubState<number>;
};

export interface IApplicationPaymentParams {
  coworkName: string;
  application: IApplication;
  achInfo?: IAchTransactionInfo;
  cardInfo?: OpaqueData;
  businessName: string;
  applicantName: string;
}

export type IPaymentReducers = {
  fetchingPaymentInfo: (state: IPaymentState) => IPaymentState;
  fetchPaymentInfoSucceeded: (
    state: IPaymentState,
    props: { monthlyFee: number }
  ) => IPaymentState;
  fetchPaymentInfoFailed: (
    state: IPaymentState,
    error: string
  ) => IPaymentState;

  postingMemberPayment: (state: IPaymentState) => IPaymentState;
  memberPaymentSucceeded: (state: IPaymentState) => IPaymentState;
  memberPaymentFailed: (state: IPaymentState, error: string) => IPaymentState;
};

export type IPaymentEffects = {
  fetchPaymentInfo: (
    params: GetDepositPaymentInfoFuncParams,
    state: IState
  ) => void;
  postMemberPayment: (params: IApplicationPaymentParams, state: IState) => void;
};

export type IPaymentDispatch = {
  fetchPaymentInfo: (params: GetDepositPaymentInfoFuncParams) => void;
  fetchingPaymentInfo: () => void;
  fetchPaymentInfoSucceeded: (props: GetDepositPaymentInfoResponse) => void;
  fetchPaymentInfoFailed: (error: string) => void;

  postMemberPayment: (params: IApplicationPaymentParams) => void;
  postingMemberPayment: () => IPaymentState;
  memberPaymentSucceeded: () => IPaymentState;
  memberPaymentFailed: (error: string) => IPaymentState;
};

export const Payments: IPaymentModel = {
  name: "payment",
  state: {
    memberPayment: {
      isPosting: false
    },
    monthlyFee: {
      isFetching: false
    }
  },
  reducers: {
    fetchingPaymentInfo: (state: IPaymentState): IPaymentState => ({
      ...state,
      monthlyFee: { isFetching: true }
    }),
    fetchPaymentInfoSucceeded: (
      state: IPaymentState,
      props: GetDepositPaymentInfoResponse
    ): IPaymentState => ({
      ...state,
      monthlyFee: { isFetching: false, prop: props.monthlyFee }
    }),
    fetchPaymentInfoFailed: (
      state: IPaymentState,
      error: string
    ): IPaymentState => ({
      ...state,
      monthlyFee: { isFetching: false, error }
    }),
    postingMemberPayment: (state: IPaymentState) => ({
      ...state,
      memberPayment: {
        isPosting: true,
        error: undefined
      }
    }),
    memberPaymentSucceeded: (state: IPaymentState) => ({
      ...state,
      memberPayment: {
        isPosting: false,
        succeeded: true
      }
    }),
    memberPaymentFailed: (state: IPaymentState, error: string) => ({
      ...state,
      memberPayment: {
        isPosting: false,
        error,
        succeeded: false
      }
    })
  },
  effects: {
    postMemberPayment,
    fetchPaymentInfo
  }
};



// WEBPACK FOOTER //
// ./src/state/modules/payment/PaymentModule.ts